// Registers our own replacements of bootstrap-vue's components and directives under bootstrap-vue's names
// (<b-button>, v-b-tooltip, this.$bvModal, ...), so templates use them unchanged. app.use() in main.js.
import BButton from '@/components/bootstrap/BButton.vue'
import BSpinner from '@/components/bootstrap/BSpinner.vue'
import BListGroup from '@/components/bootstrap/BListGroup.vue'
import BListGroupItem from '@/components/bootstrap/BListGroupItem.vue'
import BTabs from '@/components/bootstrap/BTabs.vue'
import BTab from '@/components/bootstrap/BTab.vue'
import BDropdown from '@/components/bootstrap/BDropdown.vue'
import BDropdownItem from '@/components/bootstrap/BDropdownItem.vue'
import BDropdownDivider from '@/components/bootstrap/BDropdownDivider.vue'
import BDropdownHeader from '@/components/bootstrap/BDropdownHeader.vue'
import BDropdownGroup from '@/components/bootstrap/BDropdownGroup.vue'
import BModal from '@/components/bootstrap/BModal.vue'
import { vBTooltip } from '@/components/bootstrap/vBTooltip'
import { vBPopover } from '@/components/bootstrap/vBPopover'
import { bvModal } from '@/components/bootstrap/bvModal'

export default {
  install(app) {
    app.component('BButton', BButton)
    app.component('BSpinner', BSpinner)
    app.component('BListGroup', BListGroup)
    app.component('BListGroupItem', BListGroupItem)
    app.component('BTabs', BTabs)
    app.component('BTab', BTab)
    app.component('BDropdown', BDropdown)
    app.component('BDropdownItem', BDropdownItem)
    app.component('BDropdownDivider', BDropdownDivider)
    app.component('BDropdownHeader', BDropdownHeader)
    app.component('BDropdownGroup', BDropdownGroup)
    app.component('BModal', BModal)
    app.directive('b-tooltip', vBTooltip)
    app.directive('b-popover', vBPopover)
    app.config.globalProperties.$bvModal = bvModal
  }
}
